// extracted by mini-css-extract-plugin
export var changeIcon = "_53-4";
export var clickable = "_53-8";
export var container = "_53-0";
export var divider = "_53-7";
export var externalLinkIcon = "_53-1";
export var green = "_53-5";
export var helpCircleIcon = "_53-3";
export var iconButton = "_53-2";
export var red = "_53-6";